import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import apiParticipantes from "../api/Participantes/api-participantes";
import { RootState } from "../redux/reducers";
import {
  participanteModel,
  participanteModelInitialValues,
} from "../models/ParticipantesModel/participantes.model";
import { useNavigate } from "react-router";
import { openNotification } from "../utils/saveFile";
import moment from "moment";
import { guardarDatosPostulacion } from "../redux/actions/participantesAction";
import getStorageUser from "../middlewares/GetStorageUser";
import { useEncrypt } from "./useEncrypt";
import { ObjNotificaciones } from "../config/notificaciones";
import { consolidateIdentificate } from "../utils/dataSelectOptions";

export const usePersonaNatural = () => {
  const participante = useSelector((state: RootState) => state.participantes);
  const { decrypt, encrypt } = useEncrypt();
  const dispatch = useDispatch();
  const [inforParticipante, setInforParticipante] = useState<participanteModel>(
    participanteModelInitialValues
  );
  const navigate = useNavigate();
  const [imageSelected, setImageSelected] = useState("");
  const [loading, setLoading] = useState(false);

  const cargarInformacionParticipante = async () => {
    if (localStorage.user) {
      let _user = getStorageUser()

      const user = _user;
      let { data } = await apiParticipantes.consultarParticipante(
        user.documento
      );

      if (data.length > 0) {
        if (data.path_foto !== "") {
          const imagen = await apiParticipantes.obtenerArchivo(data.path_foto);
          setImageSelected(URL.createObjectURL(imagen));
        }
      }

      let typeDocConsolidate = consolidateIdentificate.filter((x) => x.value === user.tipo_identificacion);

      let tipoDoc = typeDocConsolidate.length > 0 ? typeDocConsolidate[0].target : 'CC';



      return setInforParticipante({
        ...inforParticipante,
        primer_nombre: user.nombres,
        primer_apellido: user.apellidos,
        tipo_identificacion: tipoDoc,
        numero_documento: user.documento,
        fecha_nacimiento: data.fecha_nacimiento ? moment(data.fecha_nacimiento) : '', /*user.fecha_nacimiento,*/
        etnia: data.etnia,
        sexo: data.sexo,
        orientacion: data?.orientacion,
        identidad: data?.identidad,
        telefono_celular: data.telefono_celular,
        direccion_residencia: data.direccion_residencia,
        pais_nacimiento: data.pais_nacimiento,
        pais_residencia: data.pais_residencia,
        /*
          Estos se ponian en null, asi que la residencia se perdia de la
          pantalla en cada carga aunque estuviera guardada.

          Los nombres de aqui y los de la base no coinciden: el participante
          solo tiene las columnas departamento, municipio, comuna y barrio
          —no hay departamento_nombre ni municipio_nombre—, y el formulario
          guarda el NOMBRE dentro de esas columnas. Lo que manda como
          _nombre lo descarta Sequelize por no ser del modelo. Por eso el
          formulario lee de la columna base en los dos campos.
        */
        departamento: data.departamento ?? null,
        departamento_nombre: data.departamento ?? null,
        municipio: data.municipio ?? null,
        municipio_nombre: data.municipio ?? null,
        comuna: data.comuna ?? null,
        barrio_nombre: data.barrio ?? null,
        estrato: data.estrato,
        correo_electronico: data.correo_electronico,
        datos_empresa: data.datos_empresa && data.datos_empresa !== null ? data.datos_empresa : { nit: "", razon_social: "", direccion_empresa: "", comuna_empresa: "" }
      });
    } else {
      navigate("/login");
    }

  };
  /*
    Ya no exige la aceptacion de politicas: esa se declara al inscribir, al
    final del ultimo paso del wizard, y de ahi sale el impedimento que
    bloquea la inscripcion. Ver impedimentosParaInscribir.
  */
  const guardarInformacionParticipante = async (guardar?: boolean) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));

    if (
      parseInt(moment(inforParticipante.fecha_nacimiento).format("YYYYMMDD")) >
      parseInt(moment().format("YYYYMMDD"))
    ) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha seleccionada es mayor a la actual",
        placement: "bottomRight",
      });
    }
    setLoading(true);
    const user = getStorageUser()
    let { data } = await apiParticipantes.consultarParticipante(user.documento);
    if (!Array.isArray(data)) {

      inforParticipante.tipo_participante = 1;

      await apiParticipantes.modificarParticipante(
        user.documento,
        inforParticipante
      );
      dispatch(
        guardarDatosPostulacion({
          ...participante.datos_postulacion,
          inforParticipante,
        })
      );
      setLoading(false);

      localStorage.setItem('datosEmpresa', JSON.stringify(inforParticipante.datos_empresa))
      localStorage.setItem('ciudad', inforParticipante.municipio_nombre)
      localStorage.setItem('pais', inforParticipante.pais_residencia)

      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        return navigate("/Usuario/seleccionarCategoria");
      }
    }

    await apiParticipantes.crearParticipante(
      user.documento,
      inforParticipante
    );
    dispatch(
      guardarDatosPostulacion({
        ...participante.datos_postulacion,
        inforParticipante,
      })
    );

    if (guardar) {
      await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
      ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
      return navigate("/Usuario");
    } else {
      return navigate("/Usuario/seleccionarCategoria");
    }
  };

  /**
   * Guarda los datos personales sin sacar a la persona del formulario.
   *
   * Es la version para el autoguardado: decide igual que las otras dos entre
   * crear y modificar al participante, pero no exige las politicas ni la
   * fecha, no cambia el estado de la postulacion, no avisa y no navega. Lo
   * que falte se revisa al inscribir, no mientras se escribe.
   */
  const autoguardarParticipante = async (participante: any, tipo?: number) => {
    const user = getStorageUser();
    if (!user || !participante) return null;

    // Los datos llegan por parametro y no del estado del hook, porque cada
    // formulario tiene su propia instancia y quien guarda es otra pantalla.
    const datos = tipo ? { ...participante, tipo_participante: tipo } : participante;

    const { data } = await apiParticipantes.consultarParticipante(user.documento);
    // Un arreglo significa que todavia no existe el participante.
    const yaExiste = !Array.isArray(data);

    if (yaExiste) {
      await apiParticipantes.modificarParticipante(user.documento, datos);
      // El grupo conformado necesita este id en los pasos siguientes.
      if (data?.id_participante) {
        localStorage.setItem(
          "id_participante_grupo_conformado",
          encrypt(data.id_participante.toString())
        );
      }
      return datos;
    }

    await apiParticipantes.crearParticipante(user.documento, datos);
    return datos;
  };

  /*
    Ya no exige la aceptacion de politicas: esa se declara al inscribir, al
    final del ultimo paso del wizard, y de ahi sale el impedimento que
    bloquea la inscripcion. Ver impedimentosParaInscribir.
  */
  const guardarInformacionParticipanteGrupo = async (guardar?: boolean) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));

    if (
      parseInt(moment(inforParticipante.fecha_nacimiento).format("YYYYMMDD")) >
      parseInt(moment().format("YYYYMMDD"))
    ) {
      return openNotification({
        titulo: "Error",
        descripcion: "La fecha seleccionada es mayor a la actual",
        placement: "bottomRight",
      });
    }
    const user = getStorageUser()
    let { data } = await apiParticipantes.consultarParticipante(user.documento);
    if (!Array.isArray(data)) {
      await apiParticipantes.modificarParticipante(
        user.documento,
        inforParticipante
      );
      localStorage.setItem('id_participante_grupo_conformado', encrypt(data.id_participante.toString()));

      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        return navigate("/Usuario/seleccionarCategoria");
      }
    }

    await apiParticipantes.crearParticipante(
      user.documento,
      inforParticipante
    );

    if (guardar) {
      await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
      ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
      return navigate("/Usuario");
    } else {
      return navigate("/Usuario/agregarParticipante");
    }
  };
  return {
    infoparticipante: inforParticipante,
    setInforParticipante,
    cargarInformacionParticipante,
    guardarInformacionParticipante,
    guardarInformacionParticipanteGrupo,
    autoguardarParticipante,
    imageSelected,
    setImageSelected,
    loading,
  };
};
